<template>
<v-card>
    <v-card-text>

      <ValidationObserver
        ref="form"
        tag="form"
        @submit.prevent="save"
      >
        <ValidationProvider
            vid="calendar"
            :name="$t('fields.calendar').toLowerCase()"
            v-slot="{ errors }"
        >
            <v-container>
              <v-row>
                <v-col
                    v-for="index in 5"
                    :key="index"
                    cols="12"
                    sm="5"
                    md="2"
                >
                    <InputDataPicker
                        v-model="form.calendar[index]"
                        :key="reload"
                        :value="form.calendar[index]"
                        clearable
                    />
                    <small>{{ getDayOfWeek(form.calendar[index]) }}</small>
                </v-col>
            </v-row>
            </v-container>
        </ValidationProvider>
        <Grid
          v-model="form.cells"
          :data="data.cells"
          :key="reload"
        />


        <v-container>
          <ckeditor
            :editor="editor"
            v-model="form.body"
            :config="editorConfig"
          />
        </v-container>
    </ValidationObserver>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="save" color="primary">{{ $t('SAVE') }}</v-btn>
      <v-btn :to="{name: routeNames.CAMPAIGN_SCHOOL_RESULT }">{{ $t('CANCEL') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapActions } from 'vuex';
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
  import InputDataPicker from '../../components/shared/Inputs/InputDataPicker.vue';
  import Grid from '../../components/shared/Grid.vue';
  import { routeNames } from '../../config/router/routeNames';
  import { schoolsService } from '../../utils/services/schools.service';

  export default {
    name: 'SchoolGrid',
    components: { InputDataPicker, Grid },
    data() {
      return {
       data: {},
       form: {
          calendar: {},
          cells: {},
          body: '',
        },
        editor: ClassicEditor,
        editorConfig: {
          extraPlugins: [],
        },
        loading: false,
        routeNames,
        reload: 0,
      };
    },

    computed: {},

    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('alert', ['showToast']),

      async save() {
        const isValid = await this.$refs.form.validate();
        if (isValid) {
            schoolsService.updateSheetOptions(this.id, this.form)
            .then(() => {
              this.$router.push({ name: routeNames.CAMPAIGN_SCHOOL_RESULT });
            })
            .catch(error => {
                this.handleError(error, this.errors);
            });
        }
      },

      getDayOfWeek(date) {
        if (date) {
          const dayLabel = ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'];
          const d = new Date(date);
          const day = d.getDay();
          return dayLabel[day];
        }

        return '';
      },

      async fetchSheetOptions() {
        return schoolsService.getSheetOptions(this.id)
            .then((response) => {
              if (!Array.isArray(response.data.school.cells)) {
                this.data = response.data.school;
                this.form = response.data.school;
              }
            })
            .catch(error => {
                console.log(error);
                this.handleError(error, this.errors);
            });
      },

    },
    async created() {
      if (this.$router.currentRoute.params.id) {
        this.id = this.$router.currentRoute.params.id;
        await this.fetchSheetOptions();
        this.reload = this.reload + 1;
      }
    },
  };
</script>

<style>


</style>
